import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class StockService {
  private apiUrl = '/stocks';
  private resultmailsendApiUrl = '/spring/resultmailsend/RA6002';

  constructor(private http: HttpService) { }

  //実績送信
  sendResult(selectItems: object[], updprogramCd: string): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.resultmailsendApiUrl}`;
    const jsonUnit: object[] = [];
    for (let i = 0; i < selectItems.length; i++) {
      jsonUnit.push({
        ownerId: selectItems[i]['ownerId']
      });
    }
    const jsonInput: object = { selectItems: jsonUnit, updprogramCd: updprogramCd };
    return this.http.put(url, jsonInput);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/stock/stock.service.ts